import { useState } from "react";
import { List, X } from "@phosphor-icons/react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { href: "#inicio", label: "Início" },
    { href: "#servicos", label: "Serviços" },
    { href: "#galeria", label: "Galeria" },
    { href: "#contato", label: "Contato" },
  ];

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsMenuOpen(false);
  };

  return (
    <header 
      className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/10"
      data-testid="header"
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a 
            href="#inicio" 
            onClick={(e) => scrollToSection(e, "#inicio")}
            className="flex items-center gap-3"
            data-testid="logo-link"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_df8219ec-752a-49fc-a15a-f7f7322a223f/artifacts/83bo8qv3_image.png" 
              alt="Tomicharte Logo" 
              className="w-12 h-12 rounded-full"
            />
            <span className="font-outfit text-xl font-bold tracking-tight hidden sm:block">
              Tomicharte
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => scrollToSection(e, link.href)}
                className="nav-link text-[#A0AEC0] hover:text-white transition-colors font-medium"
                data-testid={`nav-${link.label.toLowerCase()}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href="https://wa.me/5527981761251?text=Olá! Gostaria de fazer um orçamento."
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:flex cta-button bg-[#00E5FF] text-[#03030A] px-6 py-2.5 rounded-full font-semibold hover:shadow-[0_0_20px_rgba(0,229,255,0.4)] transition-all"
            data-testid="header-cta"
          >
            <span>Fazer Orçamento</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-white"
            data-testid="mobile-menu-button"
            aria-label="Menu"
          >
            {isMenuOpen ? <X size={28} /> : <List size={28} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav 
            className="md:hidden mt-4 pb-4 border-t border-white/10 pt-4"
            data-testid="mobile-nav"
          >
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="text-[#A0AEC0] hover:text-white transition-colors font-medium py-2"
                  data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                >
                  {link.label}
                </a>
              ))}
              <a
                href="https://wa.me/5527981761251?text=Olá! Gostaria de fazer um orçamento."
                target="_blank"
                rel="noopener noreferrer"
                className="cta-button bg-[#00E5FF] text-[#03030A] px-6 py-3 rounded-full font-semibold text-center mt-2"
                data-testid="mobile-cta"
              >
                <span>Fazer Orçamento</span>
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
